<template>
    <VueSlickCarousel ref=eventsauthor :arrows="false" :dots="false" :variableWidth="true" :infinite="false" class="events-belt">
        <router-link :to="{name: 'event', params: { hash: item.hash }}" class="similar-item" @mousewheel.passive="slideByScroll($event)" v-for="item in items" :key="item.id">
            <div class="similar-image" :style="getCover(item)">
                <p class="similar-image__info">{{getDate(item.date_event)}}</p>
            </div>
            <div class="similar-tags" v-if="item.categories">
                <p>{{ item.categories[0].ru }} <span>+{{item.categories.length - 1}}</span></p>
            </div>
            <p class="similar-title">{{ item.title }}</p>
        </router-link>
    </VueSlickCarousel>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import moment from 'moment'

export default {
    name: 'EventsAuthor',
    props: {
        items: {
            type: Array,
            required: true
        }
    },
    components: {
        VueSlickCarousel
    },
    methods: {
        getDate(d_e) {
            let date = moment(d_e).locale("ru").calendar();
            return date;
        },
        getCover (item) {
            return item.cover ? {backgroundImage: 'url('+ item.cover +')'} : {}
        },
        slideByScroll(event) {
            event.deltaY === 0 ? event.deltaX > 0 ? this.$refs.eventsauthor.next() : this.$refs.eventsauthor.prev() : '';
        }
    }
}
</script>